import { IconProps, Icon } from '../IconWrapper';

export const Add = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;

  return <Icon iconId='add' />;
};
